module.exports = __webpack_public_path__ + "static/media/logo beetPOS small new.06ad8fdb.png";